(function () {
  if (window.__lonoUpsell) return;
  window.__lonoUpsell = true;

  var PROTECTION_PRODUCT_ID = 10806095184156;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var prev = null;

  function snapshot(cart) {
    var items = cart.items || [];
    var ship = items.filter(function (i) { return i.requires_shipping; })
      .reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var disc = (cart.cart_level_discount_applications || [])
      .reduce(function (s, d) { return s + d.total_allocated_amount; }, 0);
    var prot = items.filter(function (i) { return i.product_id === PROTECTION_PRODUCT_ID; })
      .reduce(function (s, i) { return s + i.quantity; }, 0);
    return {
      total: ship - disc,
      keys: items.filter(function (i) { return i.product_id !== PROTECTION_PRODUCT_ID; }).map(function (i) { return i.key; }),
      count: cart.item_count - prot,
      prot: prot
    };
  }

  /* The protection is a switch, not a product, so it should not add to the cart count. */
  function fixCounts() {
    if (!prev || !prev.prot) return;
    document.querySelectorAll('cart-count').forEach(function (el) {
      var n = parseInt(el.textContent, 10);
      if (n === prev.count + prev.prot) el.textContent = String(prev.count);
    });
  }
  var fixQueued = false;
  new MutationObserver(function () {
    if (fixQueued) return;
    fixQueued = true;
    requestAnimationFrame(function () { fixQueued = false; fixCounts(); });
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });

  function tweenBar(drawer, before, after) {
    var bar = drawer.querySelector('free-shipping-bar');
    if (!bar) return;
    var threshold = parseFloat(bar.getAttribute('threshold'));
    if (!threshold) return;
    var accent = bar.querySelector('.text-accent');
    var fmt = bar._currencyFormatter;
    var progress = bar.querySelector('progress-bar');
    var t0 = Date.now(), dur = 700;
    (function step() {
      var k = Math.min(1, (Date.now() - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      var cur = before.total + (after.total - before.total) * e;
      if (accent && accent.isConnected && fmt) {
        accent.textContent = fmt.format(Math.max(0, threshold - cur) / 100);
      }
      if (progress) progress.style.setProperty('--progress', String(Math.min(1, Math.max(0, cur / threshold))));
      if (k < 1) requestAnimationFrame(step);
    })();
    if (before.total < threshold && after.total >= threshold) {
      bar.classList.remove('lono-glow'); void bar.offsetWidth; bar.classList.add('lono-glow');
      setTimeout(function () { bar.classList.remove('lono-glow'); }, 1200);
    }
  }

  function flashNew(drawer, after, before, attempt) {
    var fresh = after.keys.filter(function (k) { return before.keys.indexOf(k) < 0; });
    var missing = false;
    fresh.forEach(function (key) {
      var input = drawer.querySelector('[data-line-key="' + key + '"]');
      var li = input && input.closest('line-item');
      if (!li) { missing = true; return; }
      li.classList.add('lono-flash');
      var chip = document.createElement('span');
      chip.className = 'lono-fly';
      chip.textContent = '+1 in cart';
      li.appendChild(chip);
      setTimeout(function () { li.classList.remove('lono-flash'); chip.remove(); }, 1300);
    });
    if (missing && attempt < 3) setTimeout(function () { flashNew(drawer, after, before, attempt + 1); }, 400);
  }

  function bump() {
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.classList.remove('lono-bump'); void el.offsetWidth; el.classList.add('lono-bump');
      setTimeout(function () { el.classList.remove('lono-bump'); }, 600);
    });
  }

  /* The size popup turns into an "added" sheet after adding; close it so the cart update is what the shopper sees. */
  function closePopup() {
    var cart = document.getElementById('cart-drawer');
    var qb = document.querySelector('quick-buy-drawer[open]');
    if (cart && cart.hasAttribute('open') && qb && typeof qb.hide === 'function') qb.hide();
  }

  function onChange(before, after) {
    fixCounts();
    if (after.keys.length > before.keys.length) closePopup();
    if (reduce) return;
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    setTimeout(function () {
      var d = document.getElementById('cart-drawer');
      if (!d) return;
      if (after.keys.length > before.keys.length) {
        tweenBar(d, before, after);
        flashNew(d, after, before, 0);
        bump();
      }
    }, 350);
  }

  /* Adding from the size popup inside the open cart: the cart updates behind it, so skip the "added" sheet. */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var el = m.target;
      if (el.tagName === 'CART-NOTIFICATION-DRAWER' && el.hasAttribute('open')) {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && drawer.hasAttribute('open') && typeof el.hide === 'function') el.hide();
      }
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });

  document.addEventListener('cart:change', function (event) {
    var cart = event && event.detail && event.detail.cart;
    if (!cart || !cart.items) return;
    var before = prev;
    prev = snapshot(cart);
    if (before) onChange(before, prev);
    else fixCounts();
  });

  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { if (!prev) { prev = snapshot(cart); fixCounts(); } })
    .catch(function () {});
})();